
















import {Component, Prop, Vue } from "vue-property-decorator";
import { DateTime } from "luxon";
import {secondsBeforeMoment} from "@common/webinarHelper";

import { ProgramDataHelper } from "../../program/helpers/ProgramDataHelper";
import { EventInterface } from "../../program/types/EventInterface";
import { State } from "../../program/types/StageState";
import Program from "../../program/Program.vue";

import {Element} from "@api/models/Element";

import { getImageUrl } from "@common/ImageUrlHelper";
import { VideoController } from "@service/components/player-panel/types/VideoController";
import { BackgroundViewName } from "@service/components/background-view/types/BackgroundViewName";
import {BackgroundViewHelper} from "@service/components/background-view/BackgroundViewHelper/BackgroundViewHelper";
import { COMINGSOON_PERIOD_IN_MINUTES } from "@common/constants";

@Component({
    name: 'StageController',
    components: { Program }
})
export default class StageController extends Vue {
    @Prop({required: true}) dataHelper: ProgramDataHelper;
    @Prop({required: true}) eventId: string;
    @Prop({required: true}) backend: string;

    timer?: NodeJS.Timeout;
    State = State;
    BackgroundViewName = BackgroundViewName;
    videoController: VideoController | null = null;
    watchingPaused = false;

    pastSessions: EventInterface[] = [];

    created() {
        this.watchHandler();
        this.watch();
    }

    activated() {
        if(!this.timer) {
            this.watch();
        }
    }

    deactivated() {
        if(this.timer) {
            clearInterval(this.timer);
            this.timer = undefined;
        }
    }

    /**
     * open session and wait for confirm if another broadcast is exist
     */
    async openSession(session: EventInterface) {
        const confirmed = await BackgroundViewHelper.checkBroadcast(this.$store, session.id, BackgroundViewName.session);

        if(confirmed) {
            this.$router.push({ name: 'ViewSession', params: { ...this.$route.params, id: session.id} });
        }
    }

    /**
     * Watching time
     */
    watch() {
        this.timer = setInterval(this.watchHandler, 2000);
    }

    watchHandler() {

        // NOTE: need optimization
        const sessionsForAnnonce = this.sessions.filter(this.filterSessionForPreview);
        const upcomingSessions = this.sessionsForUpcoming.filter(this.filterSessionForUpcoming);
        const sortedPastSessions = this.sessionsForPast
            .map(item => item)
            .sort((a, b) => {
                if (a.beginAt > b.beginAt) {
                    return -1;
                }
                if (a.beginAt < b.beginAt) {
                    return 1
                }
                return 0;
            });

        this.sessionsForAnnonce = sessionsForAnnonce;
        this.upcomingSessions = upcomingSessions;
        this.pastSessions = sortedPastSessions;
    }

    set upcomingSessions(data: any) {
        this.$store.dispatch('stage/setUpcomingSessions', data);
    }

    get upcomingSessions () {
        return this.$store.state.stage.upcomingSessions;
    }

    get sessionsForAnnonce() {
        return this.$store.state.stage.sessionsForAnnonce
    }

    set sessionsForAnnonce(data: any) {
        this.$store.dispatch('stage/setSessionsForAnnonce', data)
    }

    get broadcastQue() {
        return this.$store.state.backgroundView.broadcastQue;
    }

    closeSession() {
        this.$store.dispatch("stage/leave");
    }

    /**
     * filtering and setter is online params for sessions
     */
    filterSessionForPreview(session: EventInterface) {

        if(session.isClosed) {
            return false
        }

        const now = DateTime.local();
        if(session.beginAt <= now && session.endAt >= now) {
            Vue.set(session, 'isOnline', true)
            return true;
        }

        const leftSeconds = Math.round(secondsBeforeMoment(session.beginAt));
        if(leftSeconds >= 0 && leftSeconds <= COMINGSOON_PERIOD_IN_MINUTES * 60) {
            Vue.set(session, 'isOnline', false)
            return true;
        }

        if(session.isManualControlled || session.isStarted && session.endAt >= now) {
            return true;
        }

        return false
    }

    filterSessionForUpcoming(session: EventInterface) {
        const leftBeforeStart = Math.round(secondsBeforeMoment(session.beginAt));
        return leftBeforeStart >= COMINGSOON_PERIOD_IN_MINUTES * 60 && !session.isManualControlled && !session.isStarted;
    }

    /**
     * events, sorted by beginAt
     */
    get sessions() {
        return this.dataHelper?.agendaResource ?? [];
    }

    get sessionsForUpcoming() {
        return this.dataHelper?.upcomingAgendaResource ?? [];
    }

    get sessionsForPast() {
        return this.dataHelper?.pastAgendaResource ?? [];
    }

    get selectedEvent(): Element | undefined {
        return this.$store.getters['events/selectedEvent'];
    }

    get backgroundImageUrl(): string {
        return getImageUrl(this.backend, this.selectedEvent?.stageFileId);
    }

    destroyed() {
        if(this.timer) {
            clearInterval(this.timer)
        }
    }
}
